// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__13o2b","tab":"Tabs_tab__29KR7","tabActive":"Tabs_tabActive__1sZJv"};